
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"28","viewBox":"0 0 500 506","width":"28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M481 31H271V0h-30v31H31v450h210v31h30v-31h210zm-30 420H271v-30h-30v30H61V61h180v30h30V61h180z"}}),_c('path',{attrs:{"d":"M241 121h30v60h-30zM241 331h30v60h-30zM241 211h30v90h-30zM136 144.787l-19.394-19.394-21.213 21.213L136 187.213l70.606-70.607-21.213-21.213zM172.213 213.573L151 234.787l-21.214-21.214-21.212 21.214L129.787 256l-21.213 21.213 21.212 21.213L151 277.213l21.213 21.213 21.213-21.213L172.213 256l21.213-21.213zM172.213 333.573L151 354.787l-21.214-21.214-21.212 21.214L129.787 376l-21.213 21.213 21.212 21.213L151 397.213l21.213 21.213 21.213-21.213L172.213 376l21.213-21.213zM346 264.787l-19.394-19.394-21.213 21.213L346 307.213l70.606-70.607-21.213-21.213zM416.606 116.606l-21.213-21.213L346 144.787l-19.394-19.394-21.213 21.213L346 187.213zM382.213 333.573L361 354.787l-21.214-21.214-21.212 21.214L339.787 376l-21.213 21.213 21.212 21.213L361 397.213l21.213 21.213 21.213-21.213L382.213 376l21.213-21.213z"}})])
          )
        }
      }
    